import { IonButton, IonLabel } from "@ionic/react";
import React, { useEffect, useRef, useState } from "react";

interface Props {
  isOpen: Function;
  locations: any;
  onSelect: (location: any) => void;
}

const SelectLocationModal: React.FC<Props> = ({
  isOpen,
  locations,
  onSelect,
}) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState<boolean>(false);
  const [selectedLocation, setSelectedLocation] = useState<any>();
  const dropdownRef = useRef<HTMLDivElement | null>(null);
  const [isDisabledBtn, setIsDisabledBtn] = useState<boolean>(true);

  useEffect(() => {
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const handleClickOutside = (event: any) => {
    if (
      dropdownRef.current &&
      !dropdownRef.current.contains(event.target as Node)
    ) {
      setIsDropdownOpen(false);
    }
  };

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const handleLocationChange = (location: any) => {
    setIsDisabledBtn(false);
    setSelectedLocation(location);
  };

  const emitDataToParent = () => {
    onSelect(selectedLocation);
    setIsDropdownOpen(false);
  };

  return (
    <div className="all-generic-new-modal-center select-location-modal-main-wrap w-468-for-modal">
      <div className="select-location-modal-wrap">
        {/* <div className="cross-icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="19"
            height="19"
            viewBox="0 0 19 19"
            fill="none"
            onClick={() => isOpen(false)}
          >
            <path
              d="M15.9999 15.9999L3 3"
              stroke="#D1D1D1"
              strokeWidth="5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M16 3L3 16"
              stroke="#D1D1D1"
              strokeWidth="5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div> */}
        <h2>Select Location</h2>

        <div
          className={`custom-dropdown-wrap ${isDropdownOpen ? "open" : ""}`}
          onClick={toggleDropdown}
          ref={dropdownRef}
        >
          <IonLabel className="label" placeholder={undefined}>
            Location
          </IonLabel>

          <div className="dropdown-input input-field">
            {selectedLocation?.locationName || "Select Location"}
          </div>

          <div className="dropdown-item-wrap">
            {locations?.map((location: any) => (
              <div
                key={location.locationId}
                className="dropdown-item"
                onClick={() => handleLocationChange(location)}
              >
                {location.locationName}
              </div>
            ))}
          </div>
        </div>
        <div className="generic-modal-btn-wrap select-location-btn-wrap two-btns">
          <ul>
            <li>
              <IonButton
                className="generic-btn generic-btn-outline"
                placeholder={undefined}
                onClick={() => isOpen(false)}
              >
                Back
              </IonButton>
            </li>
            <li>
              <IonButton
                className="generic-btn bg-blue"
                placeholder={undefined}
                disabled={isDisabledBtn}
                onClick={() => {
                  emitDataToParent();
                }}
              >
                OK
              </IonButton>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};
export default SelectLocationModal;
